import DiscoveredPolicyVerifications from './DiscoveredPolicyVerifications';

export default DiscoveredPolicyVerifications;
